/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { ALL_AVAILABLE_ADD_ONS } from 'pricing-pages-lib/constants/AllAvailableAddOns';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useContext, useEffect } from 'react';
import { PlanBuilderContext } from '../../../context/PlanBuilderContext';
import { useAppSelector } from '../../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { currentSkuIdForProductSelector } from '../../../selectors/ProductsSelectors';
import { eligibleAddOnSkuIdsSelector } from '../../../selectors/RestrictionSelectors';
import { FlushedTitle } from '../SharedComponents';
import ExpandableChecklist from './ExpandableChecklist';
import { jsx as _jsx } from "react/jsx-runtime";
const AddonsPickerList = ({
  defaultOpen = false,
  screen
}) => {
  const {
    productConfigurations,
    setProductConfigurations,
    queryParamTerm,
    trackingSource
  } = useContext(PlanBuilderContext);
  const allAddonsSkuIds = useAppSelector(state => {
    return ALL_AVAILABLE_ADD_ONS.map(apiName => currentSkuIdForProductSelector(state, {
      apiName
    }));
  });
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const eligibleAddOnsSkuIds = useAppSelector(state => eligibleAddOnSkuIdsSelector(state, {
    selectedProductConfigurations: productConfigurations
  }));

  // remove any addons that are no longer eligible if the productConfigurations change
  // (e.g. if the user removes a product that makes an addon ineligible like pro -> starter on the bundle)
  useEffect(() => {
    if (productConfigurations.some(({
      skuId
    }) => allAddonsSkuIds.includes(skuId) && !eligibleAddOnsSkuIds.includes(skuId))) {
      setProductConfigurations(oldProductConfigurations => oldProductConfigurations.filter(({
        skuId
      }) => !allAddonsSkuIds.includes(skuId) || eligibleAddOnsSkuIds.includes(skuId)));
    }
  }, [hasPricingAndPurchasingSucceeded, productConfigurations]);
  const updateSelectedSkus = ({
    value,
    skuId,
    apiName,
    previousValue
  }) => {
    const newProductConfigurations = productConfigurations.filter(itemConfig => itemConfig.skuId !== skuId);
    if (value > 0) {
      newProductConfigurations.push(createProductConfig({
        skuId,
        quantity: value
      }));
    }
    setProductConfigurations(newProductConfigurations);
    getUsageTracker().track('planBuilderInteraction', {
      component: 'AddonsAndServicesPickerList',
      // this is named AddonsAndServicesPickerList to preserve historical tracking
      action: value > previousValue ? 'added item' : 'removed item',
      skuId,
      productName: apiName,
      screen,
      trackingSource
    });
  };
  const trackAccordionInteraction = (use, isAccordionOpen) => {
    getUsageTracker().track('planBuilderInteraction', {
      component: 'AddonsAndServicesPickerList',
      // this is named AddonsAndServicesPickerList to preserve historical tracking
      action: isAccordionOpen ? `opened ${use}` : `closed ${use}`,
      screen,
      trackingSource
    });
  };
  if (!hasPricingAndPurchasingSucceeded || eligibleAddOnsSkuIds.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ExpandableChecklist, {
    title: /*#__PURE__*/_jsx(FlushedTitle, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.addonsAndServices.addons.title"
      })
    }),
    subtext: /*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.addonsAndServices.addons.text"
      })
    }),
    skuIds: eligibleAddOnsSkuIds,
    use: "addons",
    selectedProductConfigurations: productConfigurations,
    onSelectedChange: updateSelectedSkus,
    trackAccordionInteraction: trackAccordionInteraction,
    defaultOpen: defaultOpen,
    queryParamTerm: queryParamTerm
  });
};
export default AddonsPickerList;